import React, { createContext, useContext, useState, useEffect } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase/config';
import { useAuth } from './AuthContext';

const SubscriptionContext = createContext();

const OWNER_EMAIL = 'ddecurtins@gmail.com';

export function useSubscription() {
  return useContext(SubscriptionContext);
}

export function SubscriptionProvider({ children }) {
  const { currentUser } = useAuth();
  const [subscription, setSubscription] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  // Owner bypass
  const isOwner = currentUser?.email === OWNER_EMAIL;

  useEffect(() => {
    if (!currentUser) {
      setSubscription(null);
      setIsLoading(false);
      return;
    }

    if (isOwner) {
      setSubscription({ status: 'active', isOwnerBypass: true });
      setIsLoading(false);
      return;
    }

    const unsubscribe = onSnapshot(
      doc(db, `customers/${currentUser.uid}/subscription/status`),
      (snap) => {
        if (snap.exists()) {
          setSubscription(snap.data());
        } else {
          setSubscription(null);
        }
        setIsLoading(false);
      },
      (error) => {
        setSubscription(null);
        setIsLoading(false);
      }
    );

    return () => unsubscribe();
  }, [currentUser, isOwner]);

  const isPro = isOwner || (subscription?.status === 'active' || subscription?.status === 'trialing');

  const value = {
    subscription,
    isPro,
    isLoading,
    isOwner,
  };

  return (
    <SubscriptionContext.Provider value={value}>
      {children}
    </SubscriptionContext.Provider>
  );
}
